<ng-container *ngIf="link">
    <div class="footer-link__container">
      <a
         *ngIf="link.path"
         [innerHtml]="link.title | translate"
         [ngClass]="{'footer-link__link--small': small, 'footer-link__link--separator': separator}"
         (click)="onLinkClicked()"
         [routerLink]="link.path"
         [target]="link.externalLink ? '_blank' : ''"
         [rel]="link.externalLink ? 'noopener,noreferrer' : ''"
         class="footer-link__link"
         [mmTestTarget]="'footer-link'">
      </a>

      <a
         *ngIf="link.externalLink"
         [innerHtml]="link.title | translate"
         [ngClass]="{'footer-link__link--small': small, 'footer-link__link--separator': separator}"
         (click)="onLinkClicked()"
         [href]="link.externalLink"
         [target]="link.externalLink ? '_blank' : ''"
         [rel]="link.externalLink ? 'noopener,noreferrer' : ''"
         class="footer-link__link"
         [mmTestTarget]="'footer-link'">
      </a>
      <app-tooltip
        *ngIf="link.tooltip"
        class="rebuy-guarantee__tooltip"
        [position]="link.tooltipPosition">
        {{ link.tooltip | translate }}
      </app-tooltip>
    </div>
  </ng-container>
